"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.removePromoCodeFromList = void 0;
const utils_1 = require("../../../utils");
const buildPath = (shoppingListId, promoCode) => `/v1/bff/appro/shopping-lists/${shoppingListId}/promo-codes/${promoCode}`;
const removePromoCodeFromList = (client) => async ({ shoppingListId, promoCode }) => {
    try {
        const { data } = await client.delete(buildPath(shoppingListId, promoCode));
        return { shoppingList: data };
    }
    catch (error) {
        if ((0, utils_1.isFunctionalApiError)(error)) {
            return {
                error: {
                    code: error.body.code,
                    message: error.body.message
                }
            };
        }
        throw error;
    }
};
exports.removePromoCodeFromList = removePromoCodeFromList;
